import React from "react";

interface NotFoundProps {
  user?: UserSlice | null;
}
interface UserSlice {
  userId: number;
  name: string;
  email: string;
  userRoles?: UserRole[];
  clientId: number;
  Role: string;
  roleId: number;
}
interface UserRole {
  roleId: number;
}

const NotFound: React.FC<NotFoundProps> = ({ user }) => {
  const isBeforeLogin = !user;
  return (
    <div className={`not-found ${isBeforeLogin ? "before-login" : ""}`}>
      <img src="/not-found.png" alt="not-found" />
      <p>The page you are looking for does not exist.</p>
    </div>
  );
};

export default NotFound;
